module.exports = __webpack_public_path__ + "img/times.b8e03995.png";